module.exports = __webpack_public_path__ + "img/bag-solid.0a7cd6f6.svg";